import { useMemo, useState } from "react";

import Form from "V2.0/components/Form";

import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import { apiBaseUrl, mcubeApiKey, phoneNumbers } from "./Form/template";
import { schema } from "./Form/schema";

const connectButton = {
  label: "Connect MCube Engage",
  style: "entire-width",
};

const template = [mcubeApiKey, apiBaseUrl, phoneNumbers];

const formSchema = {
  mcubeApiKey: schema.mcubeApiKey,
  apiBaseUrl: schema.apiBaseUrl,
  phoneNumbers: schema.phoneNumbers,
};

export default function MCubeEngageForm(props) {
  const { registerMcubeEngageConfiguration, isViewOnly } = props;

  const [formState] = useState({
    mcubeApiKey: "",
    apiBaseUrl: "",
    phoneNumbers: [],
  });

  const [loading, setLoading] = useState(false);

  const updatedTemplate = useMemo(() => {
    if (!isViewOnly) {
      return template;
    }

    return template.map((field) => {
      return {
        ...field,
        disabled: isViewOnly,
      };
    });
  }, [isViewOnly]);

  const updatedButtonInfo = !isViewOnly ? connectButton : {};

  async function connectMcubeEngage(data) {
    function init() {
      setLoading(true);
      message.loading("Connecting Mcube Engage");
    }

    function success() {
      setLoading(false);
      message.destroy();
      message.success("Mcube Engage Connected");
    }

    function error(e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to connect Mcube Engage");
    }

    registerMcubeEngageConfiguration(data, { init, success, error });
  }

  return (
    <Form
      key={JSON.stringify(formState)}
      errorMessage={{}}
      inputField={formState}
      template={updatedTemplate}
      schema={formSchema}
      buttonInfo={updatedButtonInfo}
      onSubmit={connectMcubeEngage}
      loading={loading}
      setLoading={setLoading}
    />
  );
}
